import React, {useEffect, useState} from 'react';
import useStyles from "../styles/styles";
import getEnvironment from "../utils/getEnvironment";
import useFormInputs from "../hooks/useFormInputs";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import {
    Backdrop,
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Grid, IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText, Modal,
    Paper,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import {navigate} from "@reach/router";
import useTrafficStyles from "../styles/trafficStyles";
import PanelBox from "../components/TrafficSource/PanelBox";
import { companyInfoMap, companyEmailsMap } from "../utils/CompanyMap";
import _ from "lodash";
import AddBoxIcon from "@material-ui/icons/AddBox";
import RenderInput from "../components/TrafficSource/RenderInput";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

const AddCompany = () => {
    const classes = useStyles();
    const trafficClasses = useTrafficStyles();
    const env = getEnvironment();
    const [isSaved, setIsSaved] = useState(false);
    const [isError, setIsError] = useState(false);
    const [companyEmails, setCompanyEmails] = useState([]);
    const [manualLoad, setManualLoad] = useState(false);

    const onSubmit = () => {
        let error = false;
        setIsError(error);
        let nonRequiredFields = [];
        companyInfoMap.forEach((section) => {
            section.arr.forEach((item) => {
                if (!item.required) {
                    nonRequiredFields.push(item.key);
                }
            });
        });
        Object.keys(inputs).forEach(key => {
            if (nonRequiredFields.includes(key)) {
                return
            }
            const value = inputs[key]
            if (value === '') {
                console.error(`${key} is a required field.`)
                error = true
            }
        });

        if (!error) {
            let finalInputs = _.pickBy(inputs, v => v !== '');
            let finalEmails = []
            companyEmails.forEach((rows) => {
                let obj = {};
                rows.forEach((item) => {
                    if (item.value !== '' && item.key !== 'id' && item.key !== 'companyId') {
                        obj = {
                            ...obj,
                            [item.key]: item.value
                        };
                    } else if (item.key === 'id') {
                        obj = {
                            ...obj,
                            id: item.id,
                        };
                    }  else if (item.key === 'companyId') {
                        obj = {
                            ...obj,
                            companyId: item.companyId
                        };
                    }

                    obj = {
                        ...obj,
                        delete: item.delete || false
                    };
                });
                if (Object.keys(obj).length) {
                    finalEmails.push(obj);
                }
            });
            const mutator = {
                ...finalInputs,
                companyEmails: finalEmails,
            };
            createCompany({
                variables: {
                    input: mutator
                }
            });
        } else {
            setIsError(true)
        }
    };
    const {clearAllInputs, inputs, handleSwitchChange, handleFilterChange, handleInputChange, handleSubmit, setInputs} = useFormInputs(onSubmit);

    const {loading, error, data, refetch} = useQuery(gql`
        query AddCompanyPage {
            allBillFileId: __type(name: "BillFileId") {
                enumValues {
                    name
                }
            }
        }
    `);

    const [createCompany, {data: mutationData, loading: mutationLoading}] = useMutation(gql`
        mutation CreateCompany($input: CompanyMutatorInput!) {
            createCompany(input: $input) {
                id
                billFileId
                billingName
                name
                advertiserId
                companyEmails {
                    id
                    companyId
                    email
                    primaryEmail
                }
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    const setData = (objData, objKey) => {
        companyInfoMap.forEach(section => {
            section.arr.forEach((item => {
                const {key, type} = item
                if (inputs[item.key] === undefined) {
                    const dataKey = objData[objKey][key];
                    let value = dataKey === '' ? '' : dataKey;

                    if (_.isObject(value)) {
                        value = value.enum;
                    }

                    setInputs(inputs => ({
                        ...inputs,
                        [key]: value
                    }));
                }
            }));
        });
    };

    useEffect(() => {
        if (isSaved) {
            setTimeout(() => setIsSaved(false), 5000);
            setManualLoad(false);
            refetch();

        }
    }, [isSaved]);

    useEffect(() => {
        if (data && Object.keys(data).length && data.company) {
            setData(data, 'company');
        }
    }, [data]);

    useEffect(() => {
        if (mutationLoading) {
            setManualLoad(true);
        }
    }, [mutationLoading]);

    useEffect(() => {
        if (mutationData && Object.keys(mutationData).length) {
            setTimeout(() => window.location = (`/info/companies/${mutationData.createCompany.id}`), 5000);
        }
    }, [mutationData])


    const handleEmailChanges = (idx, rowIdx, newVal) => {
        let values = [...companyEmails];
        const obj = [...values[idx]];
        obj[rowIdx] = {
            ...obj[rowIdx],
            value: newVal
        };
        values[idx] = [...obj];
        setCompanyEmails(values);
    };

    const deleteRow = (deleteIndex) => {
        const values = [...companyEmails];
        let obj = [...values[deleteIndex]];
        const newSet = obj.map(item => {
            if (item.key === 'delete') {
                item.delete = true;
            }
            return {
                ...item,
            };
        });
        values[deleteIndex] = [...newSet];
        setCompanyEmails(values);
    };

    const addRow = () => {
        const values = [...companyEmails];
        const newSet = companyEmailsMap.map(item => {
            const value = item.key === 'primaryEmail' ? false : ''
            return {
                ...item,
                value
            };
        });
        values.push(newSet);
        setCompanyEmails(values);
    };

    if (loading || manualLoad) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    if (error) {
        return (
            <Paper className={classes.paper}>
                <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                <p>
                    <a href="/#" onClick={(e) => {
                        e.preventDefault();
                        navigate('/info/companies');
                    }}>Click here to view all companies.</a>
                </p>
            </Paper>
        );
    }
    return (
        <>
            <Typography variant="h2" component="h2" className={classes.monospace}>
                Add New Company
            </Typography>
            <Paper className={classes.paper}>
                {isSaved ? (
                    <Alert severity="success">Updates Saved!</Alert>
                ) : false}
                {isError ? (
                    <Alert severity="error">Please add values to the highlighted fields!</Alert>
                ) : false}
                <Container maxWidth={false}>
                    <form id="company-form">
                        {env === 'test' ? (
                            <Box className={trafficClasses.headerBox}>
                                <Grid container alignItems="flex-end">
                                    <Grid item xs={12} style={{ minHeight: '100%' }} className={`${trafficClasses.header} ${trafficClasses.headerButtons} `}>
                                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                                            Create New
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        ) : null}
                        <Box className={trafficClasses.headerBox}>
                            <Grid container spacing={3} alignItems="flex-end">
                                {companyInfoMap.map((section, idx) => (
                                    section.title &&
                                    <PanelBox
                                        key={`${section.title} -${idx.toString()} `}
                                        panelData={section}
                                        trafficClasses={trafficClasses}
                                        editView={true}
                                        inputs={inputs}
                                        data={data}
                                        handleFilterChange={handleFilterChange}
                                        handleInputChange={handleInputChange}
                                        handleSwitchChange={handleSwitchChange}
                                        setInputs={setInputs}
                                        rowCol={12}
                                    />
                                ))}
                            </Grid>
                        </Box>
                        <Box className={`${classes.filterBox} ${trafficClasses.panelBox}`} style={{marginTop: '10px'}}>
                            <Chip
                                label={'Company Emails'}
                                className={classes.filterSectionLabels}
                            />
                            <Button
                                style={{ float: 'left' }}
                                variant="contained"
                                className={classes.addButton}
                                onClick={() => addRow()}
                                size="small"
                            >
                                Add Row <AddBoxIcon/>
                            </Button>
                            <Grid container direction="row" alignItems="flex-start" spacing={2}>
                                <Grid item xs={12} style={{ padding: '10px 0'}}>
                                    {!companyEmails.length ? (
                                        <Alert severity="warning">There are no emails.</Alert>
                                    ) : null}
                                    <List>
                                        {companyEmails.map((rows, idx) => {
                                            let isDeleted = rows.filter(obj => obj.delete);
                                            if(isDeleted.length) {
                                                return null;
                                            }
                                            return (
                                                <ListItem key={idx.toString()}>
                                                    <ListItemIcon>
                                                        <IconButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteRow(idx);
                                                            }}>
                                                            <RemoveCircleIcon/>
                                                        </IconButton>
                                                    </ListItemIcon>
                                                    {rows.map((item, objIdx) => {
                                                        const {key, value} = item;
                                                        if (key === 'email' || key === 'primaryEmail') {
                                                            return (
                                                                <ListItemText key={objIdx.toString()}>
                                                                    <RenderInput
                                                                        item={item}
                                                                        disabled={item.disabled || false}
                                                                        value={companyEmails[idx][objIdx].value}
                                                                        data={data}
                                                                        handleFilterChange={(newVal) => handleEmailChanges(idx, objIdx, newVal)}
                                                                        handleInputChange={(e) => handleEmailChanges(idx, objIdx, e.target.value)}
                                                                        handleSwitchChange={(e) => handleEmailChanges(idx, objIdx, e.target.checked)}
                                                                        setInputs={setInputs}
                                                                        inputs={inputs}
                                                                    />
                                                                </ListItemText>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
            </Paper>
        </>
    );
};

export default AddCompany;
